// extracted by mini-css-extract-plugin
export default {"wrapper":"qr-z","response":"rr-z","error":"sr-z","disabled":"tr-z","buttons":"ur-z","feedbackQuestionSection":"vr-z","yesNoWrapper":"wr-z"};